<template>
  <div class=" sm:rounded">
        <div class="divide-y divide-gray-100">
            <Cell :title="title" :p="false" :b="false" v-if="title"></Cell>
            <div class="">
                <slot></slot>
            </div>
        </div>
        <div class=" px-4 py-2 sm:px-4 sm:rounded-b-lg" v-if="footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: '_component',

    props: {
        title: {
            type: String,
        },
        footer: {
            type: Boolean,
            default: false,
        },
    }

}
</script>

<style>

</style>